import apiURLs from '../../constants/apiURLs';

class EquipmentCheckEndpoint {
  constructor(axios, setBearer, removeBearer) {
    this.axios = axios;
    this.setBearer = setBearer;
    this.removeBearer = removeBearer;
  }

  downloadTest = async () => {
    try {
      const response = await this.axios({
        method: 'GET',
        url: apiURLs.speedTestDownload,
        responseType: 'arraybuffer',
        headers: {
          'Cache-Control': 'no-store',
          Pragma: 'no-cache',
        },
      });

      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  };

  uploadTest = async data => {
    try {
      const response = await this.axios({
        method: 'GET',
        url: apiURLs.speedTestUpload,
        data,
        headers: {
          'Content-Type': 'application/octet-stream',
          'Cache-Control': 'no-store',
          Pragma: 'no-cache',
        },
      });

      return response.data;
    } catch (error) {
      throw error.response || error;
    }
  };
}

export default EquipmentCheckEndpoint;
